import { directory } from '@/api'
import {
	DIRECTORY_GET_STATUS,
	DIRECTORY_GET_ERROR,

	DIRECTORIES_GET,
	DIRECTORY_GET,
} from '@/store/directory/types'



const getDirectories = async (ctx, query) => {
	ctx.commit(DIRECTORY_GET_STATUS, true)

	try {
		const { data, headers } = await directory.getDirectories(query)

		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }

		ctx.commit(DIRECTORIES_GET, response)
		ctx.commit(DIRECTORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
		ctx.commit(DIRECTORY_GET_STATUS, false)

		console.error(e)
	}
}

const getDirectory = async (ctx, directoryId) => {
	ctx.commit(DIRECTORY_GET_STATUS, true)

	try {
		const { data } = await directory.getDirectory(directoryId)

		ctx.commit(DIRECTORY_GET, data)
		ctx.commit(DIRECTORY_GET_STATUS, false)
	} catch (e) {
		ctx.commit(DIRECTORY_GET_ERROR, e)
		ctx.commit(DIRECTORY_GET_STATUS, false)

		console.error(e)
	}
}
export default {
	getDirectory,
	getDirectories
}


